import { gql } from 'graphql-request';

export default gql`
  mutation stripeNewCustomer($data: JSON) {
    stripeNewCustomer(data: $data) {
      success
      message
      data
    }
  }
`;
